<template>
  <div class="createAccount" v-if="visible">
    <div class="createAccount__panel" @click.stop>
		  <div class="head"><img  src="@/assets/imgs/default_head.png" /></div>
      <div class="progress">
        <div class="progress_indicator"></div>
        <div class="progress_indicator progress_indicator_mark"></div>
        <div class="progress_indicator"></div>
      </div>
      <div class="createAccount__content">
        <template>
          <div class="createAccount__brand">
            {{ $t('message.createAccount.title') }}
          </div>
          <div class="createAccount__form">
              <div class="createAccount__form_item" :class="{'createAccount__form_item-input':errorInfo==null}">
                    <input
                          ref="mobile"
                          type="text"
                          v-model="accountName"
                          :placeholder="$t('message.createAccount.placeholder')"
                          @blur="onBlur"
                          @focus="onFocus"
                          autocomplete="new"
                      />
              </div>
							<div class="createAccount__form_item-errorinfo" v-if="errorInfo!=null">
								<div class="createAccount__form_item-errorinfo_icon">!</div>
								<div>{{errorInfo}}</div>
							</div>

                <div :class="accountName.length>0?'createAccount__form_item-button':'createAccount__form_item-button-disable'"
                    class="createAccount__form_item global_pointer"
                    @click="submit"
                >
                    {{ $t("message.createAccount.next") }}
                </div>
            </div>

        </template>
      </div>
    </div>
  
  </div>
</template>

<script>
import api from '@/api/api_list';
export default {
  name: 'createAccount',
  data() {
    return {
      visible: false,
      complete:null,
      accountName:null,
      errorInfo:null
    };
  },
  mounted() {
  },
  methods: {
    submit() { 
      api
        .check_user_name({
          userName: this.accountName
        })
        .then((res) => {
          if(res.code == 0){
            this.updateUserInfo()
          }else{
				    this.errorInfo = res.msg
            this.$toast(res.msg)
            if (res.code == 505262) {
              this.getRandomName()
            }
          }
        })
        .catch((err) => {
        });
    },
    getRandomName(){
       api
        .get_random_user_name({
          userName: this.accountName
        })
        .then((res) => {
          if(res.code == 0){
            let rdNames = res.result.userNameWithRandomNumList;
            if (rdNames && rdNames.length>0) {
              this.accountName = rdNames[0]
            }
          }else{
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
        });
    },
    updateUserInfo(){
       api
        .update_user_info({
          userName: this.accountName
        })
        .then((res) => {
          if(res.code == 0){
            this.visible = false
            this.complete ? this.complete(true) : null ;
          }else{
				    this.errorInfo = res.msg
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
        });
    },
    
    onFocus(evt) {
      let element = evt.target
      element.scrollIntoView(true);
      element.scrollIntoViewIfNeeded(true);
    },
    onBlur() {
      // 设置body恢复原来的高度
      // document.getElementsByTagName('body')[0].style.height = `${window.innerHeight}px`;
    },
    resetForm(){
      this.accountName = ''
    },
    open(input={}){
      let {complete} = input
      this.resetForm()
      this.visible = true

      this.complete = complete
    
    }
  },
};
</script>


<style lang="less" scoped>
.createAccount {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.5);
	background-color: rgba(0, 0, 0, 0.5);
  text-align: center;
  &__panel {
    position: absolute;
    width: 100%;
    background: #FEF7F0;
    left: 0;
    bottom: 0;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    overflow: visible;
    z-index: 110;
    &_close{
      width: 26px;
      height: 26px;
      position: absolute;
      right: 12px;
      top: 12px;
    }
  }
  .head{
    width: 92px;
    height: 92px;
    position: absolute;
    top: -46px;
    margin-left: -46px;
    left: 50%;
  }
  .progress{

		z-index: 120;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: -76px;
    margin-left: -20px;
    left: 50%;

    &_indicator{
      width: 9px;
      height: 9px;
      margin-right: 2px;
      margin-left: 2px;
      border-radius: 9px;
      border: 1px solid #ffffff;
      &_mark{
        background-color: #ffffff;
      }
    }
    
  }
  &__content{
    // position: relative;
  }
  &__line {
    border: 0;
    padding: 0;
    margin: 0;
    width: 100%;
    height: 8px;
    background: #c0ddde;
  }
  &__brand {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 60px;
    margin-bottom: 24px;
    font-size: 24px;
    font-family: Approach-Regular, Approach;
    font-weight: 400;
    color: #0D0E13;
    line-height: 30px;
  }
  &__form {
    margin-bottom: 37px;
  }
  &__form_item {
    border-bottom: 1px solid #979797;
		width: 315px;
		height: 36px;
		line-height: 36px;
		margin: 0 auto 0px;
		box-sizing: border-box;
		text-align: left;
		padding: 0 11px;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		font-family: PingFangSC-Regular, PingFang SC;
		position: relative;
    & input {
			border: 0;
			width: 275px;
			height: 24px;
			line-height: 22px;
			border-radius: 0;
			padding: 0 6px;
			margin-left: 6px;
			background-color: transparent !important;
			outline: none;
			font-family: "TradeGothicLT";
      text-align: center;

      font-size: 18px;
      font-weight: 400;
      color: #0D0E13;
		}
  }
	&__form_item-input{
		margin-bottom: 30px;
	}
  &__form_item-errorinfo{
		height: 30px;
		line-height: 30px;
		color: #D52300;
		text-align: center;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 12px;
		&_icon{
			font-size: 5px;
			width: 12px;
			height: 12px;
			line-height: 12px;
			margin-right: 4px;
			border-radius: 12px;
			border: 1px solid #D52300;
		}
	}
	&__form_item-button {
		border: 0;
		background: #000000;
		border-radius: 30px;
		text-align: center;
		font-size: 14px;
		color: #ffffff;
		justify-content: center;
		width: 347px;
		height: 51px;
		line-height: 51px;
		// box-shadow: 0 2px 4px rgba(0, 0, 0, 0.37);
		&-disable {
			font-size: 14px;
			justify-content: center;
			width: 347px;
			height: 51px;
			line-height: 51px;
			color: #000000;
			background-color: transparent;
			border-radius: 30px;
			border: 1px solid #0D0E13;
			text-align: center;
		}
	}
}
</style>